((Sort, $) => {
  'use strict';

  Shopify.queryParams = {};

  let $sortList;
  let $sortItems;
  let $activate;
  let $header;

  const cacheDom = () => {
    $sortList = $('.js-sort-list');
    $sortItems = $('.js-sort-item');
    $activate = $('.js-sort-activate');
    $header = $('.js-sale-aside-header-mobile');
  };

  const searchQuery = () => {
    let itemSet = false;
    let setActive = false;
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          if (Shopify.queryParams.sort_by) {
            setActive = true;
          }
        }
      }
    }
    if (setActive) {
      const itemName = Shopify.queryParams.sort_by || '';
      $sortItems.not('.js-sort-bar-item').each(function highlightItem() {
        const $this = $(this);
        const linkName = $this.attr('data-search');
        if (!itemSet && linkName.toLowerCase() === itemName.toLowerCase()) {
          itemSet = true;
          $this.parent('li').addClass('highlight');
          $header.text($this.text());
        }
      });
    }
  };

  const bindUIActions = () => {
    $sortItems.on('click', function sortItems(event) {
      event.preventDefault();
      const $this = $(this);
      const linkName = $this.attr('data-search');
      Shopify.queryParams.sort_by = linkName;
      location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
    });

    $activate.on('click', () => {
      if ($(window).width() < 992) {
        $sortList.slideToggle();
      }
    });
  };

  const init = (sortValue) => {
    cacheDom();
    searchQuery();
    bindUIActions();
  };

  Sort.init = init;
})(window.Sort = window.Sort || {}, jQuery);
